export const ProductItemComponent = {
  bindings: {
    product: '<',
    defaultCurrency: '<',
    onClick: '&',
  },
  templateUrl: 'products/components/product-item/product-item.html',
  controller: class ProductItemController {},
};
